import { render, staticRenderFns } from "./FrameRight.vue?vue&type=template&id=f1bbdc0e&scoped=true&"
import script from "./FrameRight.vue?vue&type=script&lang=js&"
export * from "./FrameRight.vue?vue&type=script&lang=js&"
import style0 from "./FrameRight.vue?vue&type=style&index=0&id=f1bbdc0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1bbdc0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\job_hymn\\hymn-business02\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1bbdc0e')) {
      api.createRecord('f1bbdc0e', component.options)
    } else {
      api.reload('f1bbdc0e', component.options)
    }
    module.hot.accept("./FrameRight.vue?vue&type=template&id=f1bbdc0e&scoped=true&", function () {
      api.rerender('f1bbdc0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/FrameRight.vue"
export default component.exports